import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import {faAngleDoubleLeft, faAngleDoubleRight, faChevronRight, faPlus} from "@fortawesome/free-solid-svg-icons";
import { Observable, of } from "rxjs";
import { LensConfigMode, LensSectionMode, LensSide } from "src/app/model/configuration/configuration";
import { LanguagePickerService } from "src/app/utils/language-picker/language-picker.service";
import { NewOrderStoreService } from "../new-order-store-service.service";
import { CentralRadiusComponent } from "./central-radius/central-radius.component";
import { NewOrderProposalService } from "./new-order-proposal.service";
import { ResponseViewComponent } from "./response-view/response-view.component";
import { SpectacularRefractionComponent } from "./spectacular-refraction/spectacular-refraction.component";

@Component({
    selector: 'app-new-order-proposal',
    templateUrl: './new-order-proposal.component.html',
    styleUrls: ['./new-order-proposal.component.scss']
})
export class NewOrderProposalComponent implements OnInit {

    LensSide = LensSide;

    isRightSideEnable: boolean = true;
    isLeftSideEnable: boolean = true;
    isRightSideEnable$: Observable<boolean>;
    isLeftSideEnable$: Observable<boolean>;
    dataResponseRight$: Observable<Object>;
    dataResponseLeft$: Observable<Object>;

    previousRight: boolean = true;
    previousLeft: boolean = true;

    plusIcon = faPlus;
    arrowRight = faAngleDoubleRight;
    arrowLeft = faAngleDoubleLeft;
    chevronRightIcon = faChevronRight;

    @Output() copyEmit = new EventEmitter<LensSide>();
    @Output() switchEmit = new EventEmitter<LensSide>();
    @Output() rotateEmit = new EventEmitter<boolean>();

    @ViewChild('spectacularRefractionLeft') spectacularRefractionLeft: SpectacularRefractionComponent;
    @ViewChild('spectacularRefractionRight') spectacularRefractionRight: SpectacularRefractionComponent;
    @ViewChild('centralRadiusLeft') centralRadiusLeft: CentralRadiusComponent;
    @ViewChild('centralRadiusRight') centralRadiusRight: CentralRadiusComponent;
    @ViewChild('responseRight') responseRight: ResponseViewComponent;
    @ViewChild('responseLeft') responseLeft: ResponseViewComponent;

    @ViewChild('plusCrossProposalRight') plusCrossProposalRight;
    @ViewChild('plusCrossProposalLeft') plusCrossProposalLeft;

    constructor(private newOrderStoreService: NewOrderStoreService,
                private newOrderProposalService: NewOrderProposalService,
                private languagePickerService: LanguagePickerService) {}

    ngOnInit(): void {
        this.isRightSideEnable = this.newOrderStoreService.getIsRightSideEnable();
        this.newOrderStoreService.isRightSideEnable$.subscribe(data => {
            this.isRightSideEnable = data;
            if(this.isRightSideEnable) {
                this.plusCrossProposalRight.nativeElement.style.transform = 'rotate(45deg)';
            } else {
                this.discardRight();
                this.plusCrossProposalRight.nativeElement.style.transform = 'rotate(-1deg)';
            }
        });

        this.isLeftSideEnable = this.newOrderStoreService.getIsLeftSideEnable();
        this.newOrderStoreService.isLeftSideEnable$.subscribe(data => {
            this.isLeftSideEnable = data;
            if(this.isLeftSideEnable) {
                this.plusCrossProposalLeft.nativeElement.style.transform = 'rotate(45deg)';
            } else {
                this.discardLeft();
                this.plusCrossProposalLeft.nativeElement.style.transform = 'rotate(-1deg)';
            }
        });
    }

    calculate() {
        if(this.isRightSideEnable) {
            this.spectacularRefractionRight.checkRequiredFields();
            this.centralRadiusRight.checkRequiredFields();
        }

        if(this.isLeftSideEnable) {
            this.centralRadiusLeft.checkRequiredFields();
            this.spectacularRefractionLeft.checkRequiredFields();
        }

        if(this.newOrderStoreService.getLensConfigMode() === LensConfigMode.SINGLE) {
            if(this.isRightSideEnable && this.spectacularRefractionRight.form.status === "VALID" && this.centralRadiusRight.form.status === "VALID") {
                this.dataResponseRight$ = undefined;
                this.newOrderProposalService.buildCalculationRequest([this.spectacularRefractionRight.form, this.centralRadiusRight.form])
                  .then(data => this.createData(data));
            } else if(this.isLeftSideEnable && this.spectacularRefractionLeft.form.status === "VALID" && this.centralRadiusLeft.form.status === "VALID") {
                this.dataResponseLeft$ = undefined;
                this.newOrderProposalService.buildCalculationRequest([this.spectacularRefractionLeft.form, this.centralRadiusLeft.form])
                    .then(data => this.createData(data, true));
            }
        } else if(this.spectacularRefractionRight.form.status === "VALID" && this.centralRadiusRight.form.status === "VALID" &&
                  this.spectacularRefractionLeft.form.status === "VALID" && this.centralRadiusLeft.form.status === "VALID"){
                this.dataResponseRight$ = undefined;
                this.dataResponseLeft$ = undefined;
                this.newOrderProposalService.buildCalculationRequest([this.spectacularRefractionRight.form,
                                                                   this.centralRadiusRight.form],
                                                                  [this.spectacularRefractionLeft.form,
                                                                  this.centralRadiusLeft.form]).then(data => this.createData(data));
          }
    }

    private createData(data, isLeft = false) {
        if(isLeft) {
          (data[0]) ? this.dataResponseLeft$ = of(JSON.parse(data[0]).Lens[0]) : this.dataResponseLeft$ = undefined;
        } else {
          (data[0]) ? this.dataResponseRight$ = of(JSON.parse(data[0]).Lens[0]) : this.dataResponseRight$ = undefined;
          (data[1]) ? this.dataResponseLeft$ = of(JSON.parse(data[1]).Lens[0]) : this.dataResponseLeft$ = undefined;
        }
    }

    discard() {

        if(this.isRightSideEnable) {
            this.discardRight();
        }
        if(this.isLeftSideEnable) {
            this.discardLeft();
        }
    }

    discardRight() {
        this.dataResponseRight$ = undefined;
        this.spectacularRefractionRight.clearAll();
        this.centralRadiusRight.clearAll();
    }

    discardLeft() {
        this.dataResponseLeft$ = undefined;
        this.spectacularRefractionLeft.clearAll();
        this.centralRadiusLeft.clearAll();
    }

    recalculate() {
        this.dataResponseRight$ = undefined;
        this.dataResponseLeft$ = undefined;

        this.calculate();
    }

    selectLens() {
        document.querySelector('#final-lens').scrollIntoView();
        this.newOrderStoreService.changeLensSectionMode(LensSectionMode.FINAL_LENS);

        if(this.isRightSideEnable) {
            this.newOrderStoreService.setResponseProposalRight(this.responseRight, this.centralRadiusRight.form.get('lensType').value);
        }
        if(this.isLeftSideEnable) {
            this.newOrderStoreService.setResponseProposalLeft(this.responseLeft, this.centralRadiusLeft.form.get('lensType').value);
        }

        this.discard();
    }

    copy(sideFrom: LensSide) {
        this.copyEmit.emit(sideFrom);
    }

    switch(sideFrom: LensSide) {
        this.switchEmit.emit(sideFrom);

        this.newOrderStoreService.toggleIsRightSideEnable(true);
        this.newOrderStoreService.toggleIsLeftSideEnable(true);

        if(sideFrom === LensSide.RIGHT) {
            this.plusCrossProposalRight.nativeElement.style.transform = 'rotate(-1deg)';
            this.plusCrossProposalLeft.nativeElement.style.transform = 'rotate(45deg)';
        }
        else if(sideFrom === LensSide.LEFT) {
            this.plusCrossProposalLeft.nativeElement.style.transform = 'rotate(-1deg)';
            this.plusCrossProposalRight.nativeElement.style.transform = 'rotate(45deg)';
        }
    }

    rotateLens() {
      let isDual: boolean = this.isRightSideEnable && this.isLeftSideEnable;
      this.rotateEmit.emit(isDual);
    }

    togglePlusProposalRightSide() {
        this.newOrderStoreService.toggleIsRightSideEnable();
        this.newOrderStoreService.toggleLensConfigMode();
        if(this.isRightSideEnable) {
            this.plusCrossProposalRight.nativeElement.style.transform = 'rotate(45deg)';
        } else {
            this.plusCrossProposalRight.nativeElement.style.transform = 'rotate(-1deg)';
        }
    }

    togglePlusProposalLeftSide() {
        this.newOrderStoreService.toggleIsLeftSideEnable();
        this.newOrderStoreService.toggleLensConfigMode();
        if(this.isLeftSideEnable) {
            this.plusCrossProposalLeft.nativeElement.style.transform = 'rotate(45deg)';
        } else {
            this.plusCrossProposalLeft.nativeElement.style.transform = 'rotate(-1deg)';
        }
    }

    isEnglish(): boolean {
        return this.languagePickerService.getLanguageCode() === 'en';
    }
}
